import React from 'react';

import { IconError } from '../../atoms/IconError';
import Main from '../../atoms/Main';
import {
  Container,
  ContainerText,
  Text,
  Titulo,
  ContainerTitulo,
} from './styles';

interface IContent {
  id: string;
}

const CardError = ({ id }: IContent): JSX.Element => {
  return (
    <>
      <Main>
        <ContainerText>
          <Text>REDEFINIÇÃO DE SENHA</Text>
        </ContainerText>
        <Container>
          <IconError />
          <ContainerTitulo>
            <Titulo>O TOKEN UTILIZADO NÃO É VÁLIDO.</Titulo>
          </ContainerTitulo>
        </Container>
      </Main>
    </>
  );
};

export default CardError;
